// import { Button } from "@digitallabs/one-x-ui";
import { Button } from "../../resourses/digitallabs/one-x-ui";
import React from "react";
import { getStoredFormData, setEditingMode } from "../../utils/formStorage";
import { DMQStepNames, MAIN_STEPS } from "../../constants/constants";

const QuestionStyle = {
  color: "#4B5563",
  fontSize: "14px",
  fontWeight: 400,
  display: "flex",
  alignItems: "flex-start",
};

const AnswerStyle = (isSubQuestion = false, step) => {
  return {
    color: "#1C2633",
    fontSize: "14px",
    marginLeft: isSubQuestion ? "0px" : step === MAIN_STEPS.PERSONAL_DETAILS ? "0px" : "16px",
    fontWeight: 600,
  };
};

const SubQuestionContainerStyle = {
  padding: "12px",
  marginTop: "8px",
};

const objectStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    padding: "10px",
    background: "#F9FAFB",
  },
  title: {
    fontWeight: 600,
    marginBottom: "4px",
    color: "#111827",
  },
  row: {
    fontSize: "13px",
    color: "#374151",
    marginBottom: "2px",
  },
};

const renderObjectArray = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return "—";

  return (
    <div style={objectStyles.container}>
      {arr.map((item, index) => {
        const entries = Object.entries(item).filter(([key]) => key !== "id" && item[key]);

        return (
          <div key={index} style={objectStyles.card}>
            {/* Title → first meaningful field */}
            {entries.length > 0 && <div style={objectStyles.title}>{entries[0][1]}</div>}

            {/* Remaining fields */}
            {entries.slice(1).map(([key, value]) => (
              <div key={key} style={objectStyles.row}>
                {formatLabel(key)}: {value}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

const formatLabel = (key) => {
  return key
    .replace(/([A-Z])/g, " $1") // camelCase → space
    .replace(/^./, (str) => str.toUpperCase()); // capitalize
};

const renderField = ({ field, values, parentAnswer = null, isSubQuestion = false, currentGender, step }) => {
  let answer = values[field.name];

  //  Normalize checkbox value
  const isCheckbox = field.component === "checkbox";
  if (isCheckbox) {
    answer = answer === true; // undefined/null → false
  }

  // Gender rule
  if (currentGender === "Male" && Array.isArray(field.rules) && field.rules.includes("genderFemaleOnly")) {
    return null;
  }

  //  Improved parent skip logic
  if (parentAnswer === "No" || parentAnswer === "Fully recovered" || parentAnswer === false) return null;

  // Label type
  if (field.component === "label") {
    return (
      <div key={field.name} style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
        {field.prefix_icon && <img src={`/${field.prefix_icon}`} alt="icon" height={24} style={{ marginRight: "6px" }} />}
        <div style={{ fontSize: "14px", fontWeight: 600, color: "#0C111D" }}>{field.question}</div>
      </div>
    );
  }

  const showBullet = !isSubQuestion && field.step !== 2;

  return (
    <div key={field.name} style={{ marginBottom: "12px" }}>
      <div style={QuestionStyle}>
        {showBullet && (
          <span
            style={{
              display: "inline-block",
              width: "6px",
              height: "6px",
              backgroundColor: "#000",
              borderRadius: "50%",
              marginRight: "6px",
              marginTop: "4px",
              flexShrink: 0,
            }}
          />
        )}
        <div style={{ lineHeight: "1.4" }}>{field.question}</div>
      </div>

      <div style={AnswerStyle(isSubQuestion, step)}>
        {Array.isArray(answer)
          ? answer.length === 0
            ? "—"
            : typeof answer[0] === "object"
            ? renderObjectArray(answer)
            : answer.map((item, index) => (
                <div key={index} style={{ marginBottom: "4px" }}>
                  {item}
                </div>
              ))
          : typeof answer === "boolean"
          ? answer
            ? "Yes"
            : "No"
          : field.component === "label_with_bullet"
          ? ""
          : answer || "—"}
      </div>

      {/*  FIXED SUB QUESTION LOGIC */}
      {field.sub_questions &&
        field.sub_questions.length > 0 &&
        (field.component === "checkbox"
          ? answer === true // ONLY when checked
          : answer !== "No" && answer !== "Fully recovered") && (
          <div style={SubQuestionContainerStyle}>
            {field.sub_questions.map((subField) =>
              renderField({
                field: subField,
                values,
                parentAnswer: answer,
                isSubQuestion: true,
                currentGender,
                step,
              })
            )}
          </div>
        )}
    </div>
  );
};

const FormSummary = ({ step, internalStep, goToEditInformation, schema = [], values = {} }) => {
  const stored = getStoredFormData();
  const currentGender = stored[DMQStepNames.PERSONAL_DETAILS]?.gender || "Female";

  const handleEditInfo = () => {
    setEditingMode(true);
    goToEditInformation(step, internalStep);
  };

  return (
    <div style={{ padding: "5px" }}>
      {schema.map((field) => renderField({ field, values, currentGender, step }))}
      <br />
      <Button size="sm" variant="secondary" fullWidth onClick={handleEditInfo}>
        Edit Information
      </Button>
    </div>
  );
};

export default FormSummary;
